import { useMemo } from "react"
import { DataGrid } from "@/core/components"
import { GridColDef } from "@mui/x-data-grid-pro"
import { CSVRow, IMailingFormData } from "./csvForm"
import { v4 as uuidv4 } from "uuid"
import { useFormContext } from "react-hook-form"
import { BodyFieldsPropperties } from "../../../constants"
import { useMailingFields } from "@/modules/telegram/hooks/useMailingFields"
import { PreviewFab } from "../../TelegramPreview"
import { buildRowBody } from "./buildRowBody"

type PreviewRow = CSVRow & { __previewId: string }

interface IProps {}
export const CSVPreview = (props: IProps) => {
  const formContext = useFormContext<IMailingFormData>()
  const method = formContext.watch("method")
  const fields = useMailingFields(method).filter(
    (key) => !BodyFieldsPropperties[method][key].hidden,
  )
  const csvRows = formContext.watch("rows")
  const collation = formContext.watch("collation")
  // RHF мутирует объект `collation` на месте, поэтому его ссылка стабильна и
  // useMemo по ней не пересчитывается. Используем сериализованное значение,
  // чтобы реагировать на изменение самого сопоставления.
  const collationKey = JSON.stringify(collation ?? {})

  // Стабильный id строки, чтобы клик по «Предпросмотр» не сбрасывался
  // ремаунтом ячейки при ре-рендере грида.
  const rows = useMemo<PreviewRow[]>(
    () => (csvRows ?? []).map((row, i) => ({ ...row, __previewId: String(i) })),
    [csvRows],
  )

  const columns = useMemo<GridColDef<PreviewRow>[]>(() => {
    const previewColumn: GridColDef<PreviewRow> = {
      field: "__preview",
      headerName: "Предпросмотр",
      sortable: false,
      filterable: false,
      disableExport: true,
      disableColumnMenu: true,
      align: "center",
      headerAlign: "center",
      width: 130,
      renderCell: (params) => (
        <PreviewFab
          method={method}
          body={buildRowBody(method, params.row, collation)}
          iconOnly
        />
      ),
    }

    const dataColumns = fields
      .filter((f) => collation?.[f] != null)
      .map<GridColDef<PreviewRow>>((key) => ({
        type: "string",
        headerName: BodyFieldsPropperties[method][key].name ?? key,
        field: collation?.[key] ?? uuidv4(),
        flex: 1,
      }))

    return [...dataColumns, previewColumn]
  }, [method, collationKey, rows])

  return (
    <DataGrid<PreviewRow>
      columns={columns}
      rows={rows}
      rowCount={rows.length}
      getRowId={(row) => row.__previewId}
      filterMode="client"
      sortingMode="client"
    />
  )
}
